import React from "react";
import { Col, Space } from "antd";

import * as String from "../../commons/string";
import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function GreenCamp() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">{String.titleGreenCamp2024}</h3>
                <EventUserList eventId={5} />
                <EventPrizeList eventId={5} />
            </Space>
        </div>
    );
}

export default GreenCamp;
